import { SIDEBAR_COOKIE_NAME } from "@components/ui/sidebar"

// SidebarProvider persists its state in a cookie but never reads it back, so we restore it on load
export const getSidebarDefaultOpen = () => {
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${SIDEBAR_COOKIE_NAME}=`))

  return cookie?.split("=")[1] !== "false"
}
